import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import api from '../../../conf/api'; // Adjust to your API path

const CategoryMultiSelect = ({ selectedCategories, setSelectedCategories }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const res = await api.get('/users/categories/');
            setOptions(res.data);
        } catch (err) {
            console.error('Error fetching categories:', err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <Autocomplete
            multiple
            size='small'
            options={options}
            getOptionLabel={(option) => option.name}
            value={selectedCategories}
            onChange={(event, newValue) => setSelectedCategories(newValue)}
            filterSelectedOptions
            loading={loading}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label="Select Categories"
                    placeholder="Categories"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default CategoryMultiSelect;
